import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import NodeList from "@/components/common/Sidebar/NodeList.vue";
import NodeItem from "@/components/common/Sidebar/NodeItem.vue";
import { mapGetters } from "vuex";
import * as accountTypes from "@account/store/types";
import api from "../api";

export interface MenuInfo {
    name: string;
    id: Number;
    icon: string;
    select: boolean;
    expand: boolean;
    child?: MenuInfo[];
    path: string;
    type: string;
}

@Component({
    components: { NodeList, NodeItem },
    computed: {
        ...mapGetters({
            userCurrent: accountTypes.CURRENT,
        }),
    },
})
export default class BoardFolderList extends Vue {
    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    userCurrent!: account.TCurrent;

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    menuPermission: account.TPermissionMenu[] = [];
    menus: MenuInfo[] = [];
    newArticleBoard: number[] = [];

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    makeMenu(childItems: appbase.cache.TMenuItem[], parentMenu: MenuInfo) {
        this.menuPermission = this.userCurrent.permissions.menues;
        childItems.forEach((item) => {
            var menuItem: MenuInfo = {
                name: "",
                id: 0,
                icon: "folder",
                select: false,
                expand: true,
                path: "board-list",
                type: "",
                child: [],
            };

            if (this.menuPermission.find((x) => x.id == item.menuId)) {
                menuItem.name = this.userCurrent.userConfig.language === "ko-KR" ? item.menuName : item.menuNameEn;
                menuItem.id = item.systemId;
                menuItem.type = item.menuType == "BB" ? "router-link" : "";

                parentMenu?.child?.push(menuItem);

                if (item.hasChildren) {
                    console.log("item", item);
                    this.makeMenu(item.children, menuItem);
                }
            }
        });
    }

    updateIsNewIcon(menus: MenuInfo[]) {
        // 메뉴가 존재하는지 확인
        if (!menus || menus.length === 0) return;

        // 각 메뉴에 대해 재귀적으로 탐색
        menus.forEach((menu: any) => {
            // 현재 메뉴의 id가 newArticleBoard에 포함되는지 확인
            if (this.newArticleBoard.includes(menu.id)) {
                this.$set(menu, "hasNewIcon", true);
            } else {
                this.$set(menu, "hasNewIcon", false);
            }
            // 하위 메뉴가 있을 경우 재귀 호출
            if (menu.child && menu.child.length > 0) {
                this.updateIsNewIcon(menu.child);
            }
        });
    }

    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: W A T C H : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //

    @Watch("newArticleBoard", { immediate: true })
    isShowNewIcon() {
        if (this.menus && this.newArticleBoard.length > 0) {
            this.updateIsNewIcon(this.menus);
        }
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    created() {
        if (!this.menus.length) {
            const { menu } = this.portalCache;
            this.menuPermission = this.userCurrent.permissions.menues;

            var boardMenu = menu.items.find((x) => x.menuName == "게시판" && x.menuType == "TX");
            boardMenu?.children
                .filter((x) => x.isUseMobile)
                .forEach((menu) => {
                    var menuItem: MenuInfo = {
                        name: "",
                        id: 0,
                        icon: "folder",
                        select: false,
                        expand: true,
                        path: "board-list",
                        type: "",
                        child: [],
                    };

                    if (this.menuPermission.find((x) => x.id == menu.menuId)) {
                        menuItem.name = this.userCurrent.userConfig.language === "ko-KR" ? menu.menuName : menu.menuNameEn;
                        menuItem.id = menu.systemId;
                        menuItem.type = menu.menuType == "BB" ? "router-link" : "";

                        this.menus.push(menuItem);

                        if (menu.hasChildren) {
                            this.makeMenu(menu.children, menuItem);
                        }
                    }
                });
        }

        this.getNewArticleBoard();
    }

    getNewArticleBoard() {
        api.board.fetchNewArticleBoardId().then((res) => {
            if (res) {
                this.newArticleBoard = Object(res);
                return this.newArticleBoard;
            } else {
                console.log("Error :" + res);
            }
        });
    }
}
